import type { ReactElement } from 'react';
import { useModalDialog } from '@/shared/lib';
import { Button, DialogFrame } from '@/shared/ui';

interface OrderUnpaidCancelDialogProps {
  readonly onConfirm: () => void;
  readonly onClose: () => void;
  readonly pending: boolean;
  /** 아직 결제 대기인지 — 아니면(상태 충돌로 다시 읽은 주문이 결제됨) 안내만 남기고 확인 버튼을 막는다. */
  readonly confirmable: boolean;
  readonly message: string | null;
}

/** 결제 대기 주문 취소 확인(견적 설계 §7-9) — 모달로 띄우고, 처리 중에는 Escape 로 닫지 않는다. */
export const OrderUnpaidCancelDialog = ({
  onConfirm,
  onClose,
  pending,
  confirmable,
  message,
}: OrderUnpaidCancelDialogProps): ReactElement => {
  const modal = useModalDialog(onClose, !pending);

  return (
    <DialogFrame
      modal={modal}
      title="주문 취소 확인"
      footer={
        <>
          <Button
            type="button"
            variant="destructive"
            disabled={pending || !confirmable}
            onClick={onConfirm}
          >
            주문 취소 확인
          </Button>
          <Button type="button" variant="ghost" disabled={pending} onClick={onClose}>
            닫기
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <p>결제 대기 주문을 취소하시겠습니까?</p>
        {/* 서버(cancelPendingOrderWithin)는 견적을 발행됨(유효기한이 지났으면 만료)으로 되돌리고 디자인은 건드리지 않는다. */}
        <p className="text-muted-foreground">
          취소한 주문은 되돌릴 수 없지만, 견적과 디자인은 그대로 남아 견적 유효기한 안에 다시 주문할
          수 있습니다.
        </p>
        {message ? (
          <p role="alert" className="text-destructive">
            {message}
          </p>
        ) : null}
      </div>
    </DialogFrame>
  );
};
